export class AiThinkingTimer {
  private startedAt: number | null = null;
  private accumulatedMs = 0;

  constructor(private readonly now: () => number = () => performance.now()) {}

  get totalMs(): number { return this.accumulatedMs; }

  start(): void {
    this.startedAt = this.now();
  }

  currentMs(): number {
    if (this.startedAt === null) return 0;
    return Math.max(1, Math.round(this.now() - this.startedAt));
  }

  complete(): number {
    if (this.startedAt === null) return 0;
    const elapsedMs = this.currentMs();
    this.accumulatedMs += elapsedMs;
    this.startedAt = null;
    return elapsedMs;
  }

  cancel(): void {
    this.startedAt = null;
  }

  reset(): void {
    this.startedAt = null;
    this.accumulatedMs = 0;
  }
}

export function formatMatchDuration(milliseconds: number): string {
  const totalSeconds = Math.floor(Math.max(0, milliseconds) / 1_000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}分${seconds.toString().padStart(2, '0')}秒`;
}
